import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { memo } from "react";
type InputNumberProps = {
  placeholder?: string;
  onChange?: (e: any) => void;
  value?: number;
  id?: string;
  name?: string;
  min?: number;
  max?: number;
  required?: boolean;
  disabled?: boolean;
  className?: string;
};
const CustomInputNumber = memo(
  ({
    placeholder,
    onChange,
    value,
    id,
    name,
    min,
    max,
    required,
    disabled,
    className,
  }: InputNumberProps) => {
    return (
      <InputText
        keyfilter="int"
        placeholder={placeholder}
        onChange={onChange}
        value={value?.toString()}
        name={name}
        id={id}
        required={required}
        disabled={disabled}
        min={min}
        max={max}
        className={className}
        autoComplete="false"
      />
    );
  }
);

export default CustomInputNumber;
